import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ArgonBox from "components/ArgonBox";
import Cookies from "js-cookie";

const WhatsAppButtonWrapper = styled(ArgonBox)(({ theme }) => ({
  position: "fixed",
  bottom: "30px",
  right: "30px",
  zIndex: 1000,
  width: "60px",
  height: "60px",
  borderRadius: "50%",
  backgroundColor: "#25D366",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  boxShadow: "0 4px 12px rgba(37, 211, 102, 0.4)",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "scale(1.1)",
    boxShadow: "0 6px 16px rgba(37, 211, 102, 0.6)",
  },
  "&:active": {
    transform: "scale(0.95)",
  },
}));

const WhatsAppIcon = styled("svg")({
  width: "35px",
  height: "35px",
});

function WhatsAppButton({ phoneNumber = "59895381577", message = "" }) {
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [empresaData, setEmpresaData] = useState(null);

  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        const token = Cookies.get("empresasJWT") || localStorage.getItem("empresasJWT");
        if (!token) return;

        // Obtener datos del usuario
        const userResponse = await fetch(`${process.env.REACT_APP_API_URL}/datos-usuario`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (userResponse.ok) {
          const user = await userResponse.json();
          setUserData(user);
        }

        // Obtener datos de la empresa desde localStorage
        const empresaDataStr = localStorage.getItem("empresaData");
        if (empresaDataStr) {
          try {
            const empresa = JSON.parse(empresaDataStr);
            setEmpresaData(empresa);
          } catch (e) {
            console.error("Error al parsear datos de la empresa:", e);
          }
        }
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    obtenerDatos();
  }, []);

  // Ocultar el botón en las páginas de autenticación
  if (location.pathname.startsWith("/authentication")) {
    return null;
  }

  const handleClick = () => {
    const num = phoneNumber || "59895381577";
    
    // Construir el mensaje personalizado
    let finalMessage = message;
    if (!finalMessage && userData && empresaData) {
      const nombreCompleto = `${userData.nombre || ""} ${userData.apellido || ""}`.trim();
      const nombreEmpresa = empresaData.nombre || "mi empresa";
      finalMessage = `Hola, mi nombre es ${nombreCompleto || "un usuario"}, de la empresa ${nombreEmpresa}, necesito ayuda con el panel de PayFlex`;
    } else if (!finalMessage && userData) {
      const nombreCompleto = `${userData.nombre || ""} ${userData.apellido || ""}`.trim();
      finalMessage = `Hola, mi nombre es ${nombreCompleto || "un usuario"}, necesito ayuda con el panel de PayFlex`;
    }

    const encodedMessage = encodeURIComponent(finalMessage);
    const whatsappUrl = `https://wa.me/${num.replace(/\s/g, "")}${finalMessage ? `?text=${encodedMessage}` : ""}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <WhatsAppButtonWrapper onClick={handleClick}>
      <WhatsAppIcon viewBox="0 0 24 24" fill="white">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </WhatsAppIcon>
    </WhatsAppButtonWrapper>
  );
}

WhatsAppButton.defaultProps = {
  phoneNumber: "59895381577",
  message: "",
};

WhatsAppButton.propTypes = {
  phoneNumber: PropTypes.string,
  message: PropTypes.string,
};

export default WhatsAppButton;

